<template>
  <div>
    <div class="logo">
      <img alt="Microtronics Logo" src="@/assets/mt_logo.svg" height="45px">
    </div>
    <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

      <!-- Sidenav toggle -->
      <b-navbar-nav class="align-items-lg-center mr-auto mr-lg-4" v-if="sidenavToggle">
        <a class="nav-item nav-link px-0 ml-2 ml-lg-0" href="javascript:void(0)" @click="toggleSidenav">
          <i class="ion ion-md-menu text-large align-middle" />
        </a>
      </b-navbar-nav>

      <!-- Navbar toggle -->
      <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

      <b-collapse is-nav id="app-layout-navbar">
        <b-navbar-nav class="align-items-lg-center">
          <b-nav-form>
            <i class="ion ion-ios-search navbar-icon align-middle"></i>
            <b-form-input class="mr-sm-2" placeholder="Search..." style="margin: 10px 0px 9px 10px;"></b-form-input>
          </b-nav-form>
        </b-navbar-nav>
        <b-navbar-nav class="align-items-lg-center ml-auto">
          <b-nav-item href="#"><i class="ion ion-ios-notifications navbar-icon align-middle" style="font-size: 1.55em;margin-right:8px;"></i></b-nav-item>
          <b-nav-item href="#"><i class="ion ion-ios-contact navbar-icon align-middle" style="font-size: 1.55em;"></i></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'app-layout-navbar',

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    }
  }
}
</script>

<style scoped>
  .logo {
    display: block;
    background: var(--yellow);
    position: fixed;
    top: 0;
    left: 0;
    padding: 12px 10px 10px 29px;
    height: 63px;
    width: 250px;
    z-index: 5000;
  }

  .layout-fixed-offcanvas.layout-navbar-fixed:not(.layout-collapsed) .layout-2 .layout-navbar {
    left: 15.625rem;
  }

  @media screen and (min-width: 992px) {
    .logo {
      display: none;
    }
  }
</style>
